export const shouldFullstoryRecord = ['staging', 'production'].includes(process.env.REACT_APP_ENV);
